var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g2, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _g3, _g4, _g5, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _g6, _g7, _g8, _g9, _g10, _g11, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQ2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 408.9,
    height: 118.455,
    viewBox: "0 0 408.9 118.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_237",
    "data-name": "Rettangolo 237",
    width: 107.655,
    height: 117,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_230",
    "data-name": "Rettangolo 230",
    width: 88.65,
    height: 71.662,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_225",
    "data-name": "Rettangolo 225",
    width: 36.487,
    height: 45.421,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_226",
    "data-name": "Rettangolo 226",
    width: 80.993,
    height: 46.441,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_227",
    "data-name": "Rettangolo 227",
    width: 51.958,
    height: 47.444,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_228",
    "data-name": "Rettangolo 228",
    width: 53.127,
    height: 33.807,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_236",
    "data-name": "Rettangolo 236",
    width: 8.31,
    height: 6.01,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_231",
    "data-name": "Rettangolo 231",
    width: 7.035,
    height: 3.783,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_233",
    "data-name": "Rettangolo 233",
    width: 7.548,
    height: 5.892,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_234",
    "data-name": "Rettangolo 234",
    width: 1.778,
    height: 2.287,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3372",
    "data-name": "Tracciato 3372",
    d: "M1.3,23.147C.483,23.771.234,25.089.1,26.3l10.846-6.3c.134-1.209.383-2.527,1.2-3.15Z",
    transform: "translate(-0.1 -16.844)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_244",
    "data-name": "Rettangolo 244",
    width: 17.578,
    height: 15.894,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3375",
    "data-name": "Tracciato 3375",
    d: "M2.055,22.762l9.524-5.534a2.841,2.841,0,0,1,2.865.28L4.921,23.043a2.844,2.844,0,0,0-2.866-.28",
    transform: "translate(-2.055 -16.957)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_238",
    "data-name": "Rettangolo 238",
    width: 11.271,
    height: 5.806,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_239",
    "data-name": "Rettangolo 239",
    width: 10.641,
    height: 5.999,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3378",
    "data-name": "Tracciato 3378",
    d: "M16.574,26.908,7.051,32.442a2.819,2.819,0,0,0,1.175-2.583,8.845,8.845,0,0,0-4.014-6.953l9.523-5.534a8.842,8.842,0,0,1,4.014,6.953,2.818,2.818,0,0,1-1.175,2.583",
    transform: "translate(-4.212 -17.372)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_240",
    "data-name": "Rettangolo 240",
    width: 13.043,
    height: 9.962,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_241",
    "data-name": "Rettangolo 241",
    width: 10.698,
    height: 10.642,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_242",
    "data-name": "Rettangolo 242",
    width: 8.054,
    height: 10.36,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_252",
    "data-name": "Rettangolo 252",
    width: 19.758,
    height: 14.889,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_246",
    "data-name": "Rettangolo 246",
    width: 14.125,
    height: 6.911,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3384",
    "data-name": "Tracciato 3384",
    d: "M.933,23.091l10.845-6.3a3.515,3.515,0,0,1,3.281.34l-10.846,6.3a3.509,3.509,0,0,0-3.279-.34",
    transform: "translate(-0.933 -16.521)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_248",
    "data-name": "Rettangolo 248",
    width: 13.113,
    height: 8.384,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3386",
    "data-name": "Tracciato 3386",
    d: "M3.4,23.281l10.846-6.3a7.871,7.871,0,0,1,2.267,2.082l-10.846,6.3A7.865,7.865,0,0,0,3.4,23.281",
    transform: "translate(-3.401 -16.978)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_249",
    "data-name": "Rettangolo 249",
    width: 12.972,
    height: 12.2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3389",
    "data-name": "Tracciato 3389",
    d: "M5.107,24.847l10.846-6.3a10.284,10.284,0,0,1,2.125,5.9l-10.845,6.3a10.292,10.292,0,0,0-2.126-5.9",
    transform: "translate(-5.107 -18.545)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_250",
    "data-name": "Rettangolo 250",
    width: 8.912,
    height: 8.586,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3429",
    "data-name": "Tracciato 3429",
    d: "M48.447,18.76a1.325,1.325,0,0,1-1.191.191.419.419,0,0,1-.3-.3l3.156,18.7a.429.429,0,0,0,.3.3,1.337,1.337,0,0,0,1.191-.193.431.431,0,0,0,.193-.388l-1.228-7.259L48.64,18.373a.427.427,0,0,1-.193.387",
    transform: "translate(-46.958 -18.373)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3438",
    "data-name": "Tracciato 3438",
    d: "M53.362,36.106a.425.425,0,0,0-.177.388,1.328,1.328,0,0,0,.6,1.043.43.43,0,0,0,.432.043l6.345-3.732,10-5.877a.428.428,0,0,1-.431-.043,1.328,1.328,0,0,1-.6-1.044.424.424,0,0,1,.177-.387Z",
    transform: "translate(-53.185 -26.497)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Domanda_3.2",
    "data-name": "Domanda 3.2",
    transform: "translate(14.213 -103)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_703",
    "data-name": "Raggruppa 703",
    transform: "translate(246.796 251.995) rotate(179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_720",
    "data-name": "Raggruppa 720",
    transform: "translate(-47.792 16.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3778",
    "data-name": "Tracciato 3778",
    d: "M11.055,70.787C-7.6,63.706,2.288,46.6,5.481,31.059c.882-4.3,8.185-8.432,21.18-11.332,28.361-6.321,60.375-2.1,88.142,1.373,22.026,2.754,49.858,5.047,70.19,1.6,14.839-2.515,19.951-7.183,27.314-11.214,9.484-5.19,26.144-10.092,48.9-11.238,28.589-1.44,56.913,3.6,71.46,9.8s19.179,13.436,27.584,20.277c12.008,9.783,32.027,18.934,41.8,28.864s7.414,21.43-20.614,29c-22.072,5.958-56.758,8.435-89.57,8.007s-64.152-3.443-93.557-7.034c-23.515-2.87-47.4-6.213-73.671-6.365-17.454-.1-52.934.142-68.715-1.688-17.36-2.013-34.463-6.368-44.87-10.32",
    transform: "translate(-100.734 18.414)",
    fill: "#3f3d94"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_392",
    "data-name": "Raggruppa 392",
    transform: "translate(36.345 103)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3282",
    "data-name": "Tracciato 3282",
    d: "M43.585,33.38l.005,1.749,34.759,20.2-.005-1.749Z",
    transform: "translate(14.327 10.973)",
    fill: "#c5c5c5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3283",
    "data-name": "Tracciato 3283",
    d: "M69.745,50.732l.005,1.749,14.977-8.687,0-1.749Z",
    transform: "translate(22.926 13.821)",
    fill: "#898989"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3284",
    "data-name": "Tracciato 3284",
    d: "M43.585,35.53l34.759,20.2,14.979-8.687-34.761-20.2Z",
    transform: "translate(14.327 8.824)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3285",
    "data-name": "Tracciato 3285",
    d: "M56.346,34.072,50.737,37.31l-5.61-3.238,5.61-3.238Z",
    transform: "translate(14.834 10.136)",
    fill: "#00447d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3286",
    "data-name": "Tracciato 3286",
    d: "M61.552,31.066,55.944,34.3l-5.61-3.238,5.61-3.238Z",
    transform: "translate(16.546 9.148)",
    fill: "#00447d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3287",
    "data-name": "Tracciato 3287",
    d: "M61.365,36.969l-5.609,3.238-5.61-3.238,5.61-3.238Z",
    transform: "translate(16.484 11.088)",
    fill: "#00447d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3288",
    "data-name": "Tracciato 3288",
    d: "M66.571,33.964,60.962,37.2l-5.61-3.238,5.61-3.238Z",
    transform: "translate(18.195 10.1)",
    fill: "#00447d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3289",
    "data-name": "Tracciato 3289",
    d: "M66.383,39.867l-5.609,3.238-5.61-3.238,5.61-3.238Z",
    transform: "translate(18.134 12.041)",
    fill: "#00447d"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3290",
    "data-name": "Tracciato 3290",
    d: "M71.59,36.861,65.981,40.1l-5.61-3.238,5.61-3.238Z",
    transform: "translate(19.845 11.053)",
    fill: "#00447d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3291",
    "data-name": "Tracciato 3291",
    d: "M71.4,42.765,65.793,46l-5.61-3.238,5.61-3.238Z",
    transform: "translate(19.783 12.993)",
    fill: "#00447d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3292",
    "data-name": "Tracciato 3292",
    d: "M76.608,39.759,71,43l-5.61-3.238L71,36.521Z",
    transform: "translate(21.495 12.005)",
    fill: "#00447d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3293",
    "data-name": "Tracciato 3293",
    d: "M76.421,45.662,70.812,48.9,65.2,45.662l5.61-3.238Z",
    transform: "translate(21.433 13.946)",
    fill: "#00447d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3294",
    "data-name": "Tracciato 3294",
    d: "M81.627,42.656l-5.609,3.238-5.61-3.238,5.61-3.238Z",
    transform: "translate(23.144 12.958)",
    fill: "#00447d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3295",
    "data-name": "Tracciato 3295",
    d: "M34.782,32.871l-.013,4.508L15.15,48.863l.013-4.508Z",
    transform: "translate(4.98 10.806)",
    fill: "#fa403f"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3296",
    "data-name": "Tracciato 3296",
    d: "M16.619,42.377l-.012,4.508L10.721,43.4l.013-4.508Z",
    transform: "translate(3.524 12.784)",
    fill: "#8b2323"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3297",
    "data-name": "Tracciato 3297",
    d: "M36.235,33.733,16.616,45.218,10.731,41.73,30.35,30.246Z",
    transform: "translate(3.528 9.943)",
    fill: "#9c2827"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3298",
    "data-name": "Tracciato 3298",
    d: "M55.774,61.078l5.278-3.068,1.624-.266L57.4,60.811Z",
    transform: "translate(18.334 18.982)",
    fill: "#1c1e20"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3299",
    "data-name": "Tracciato 3299",
    d: "M56.394,57.049l5.278-3.068,1.925,1L58.319,58.05Z",
    transform: "translate(18.537 17.745)",
    fill: "#21221f"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3300",
    "data-name": "Tracciato 3300",
    d: "M68.648,70.955l5.278-3.068-1.281,3.659-5.278,3.067Z",
    transform: "translate(22.145 22.316)",
    fill: "#1d1f20"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3301",
    "data-name": "Tracciato 3301",
    d: "M58.806,55.049l5.278-3.068,1.713,2-5.278,3.067Z",
    transform: "translate(19.331 17.087)",
    fill: "#21221f"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3302",
    "data-name": "Tracciato 3302",
    d: "M69.179,67.945l5.278-3.067.8,5-5.278,3.068Z",
    transform: "translate(22.74 21.327)",
    fill: "#21221f"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3303",
    "data-name": "Tracciato 3303",
    d: "M62.366,55.548l5.278-3.068,1.04,2.465-5.278,3.068Z",
    transform: "translate(20.501 17.251)",
    fill: "#21221f"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3304",
    "data-name": "Tracciato 3304",
    d: "M60.095,56.885l5.278-3.068,3.019-1.337-5.279,3.068Z",
    transform: "translate(19.754 17.251)",
    fill: "#1c1e1f"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3305",
    "data-name": "Tracciato 3305",
    d: "M68.393,63.978l5.278-3.067,2.665,5-5.278,3.067Z",
    transform: "translate(22.482 20.023)",
    fill: "#21221f"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3306",
    "data-name": "Tracciato 3306",
    d: "M66.119,58.414,71.4,55.347l.09,2.267L66.21,60.681Z",
    transform: "translate(21.734 18.194)",
    fill: "#21221f"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3307",
    "data-name": "Tracciato 3307",
    d: "M63.149,57.4l5.278-3.068,3.948,1.345L67.1,58.746Z",
    transform: "translate(20.758 17.861)",
    fill: "#21221f"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3308",
    "data-name": "Tracciato 3308",
    d: "M66.187,60.12l5.278-3.067,3.817,3.663L70,63.785Z",
    transform: "translate(21.757 18.755)",
    fill: "#21221f"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3309",
    "data-name": "Tracciato 3309",
    d: "M64.533,54.953l1.04,2.465,3.946,1.343.09,2.267,3.817,3.665-.886,1.463,2.665,5-1.621.267.8,5-1.925-1-1.281,3.658-1.713-2-3.018,1.337-1.04-2.465L61.461,74.61l-.089-2.265L57.555,68.68l.885-1.463-2.665-5,1.622-.266-.8-5,1.925,1L59.8,54.29l1.713,2Z",
    transform: "translate(18.334 17.846)",
    fill: "#373b3e"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3310",
    "data-name": "Tracciato 3310",
    d: "M69.279,62.878l5.278-3.068-.885,1.463-5.278,3.068Z",
    transform: "translate(22.482 19.661)",
    fill: "#1c1e20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_318",
    "data-name": "Raggruppa 318",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_317",
    "data-name": "Raggruppa 317",
    clipPath: "url(#clip-path)"
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3311",
    "data-name": "Tracciato 3311",
    d: "M60.446,58.127c-2.243,1.3-2.243,5.494,0,9.379s5.88,5.985,8.122,4.69,2.244-5.5,0-9.381-5.88-5.985-8.122-4.689",
    transform: "translate(19.317 18.982)",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3312",
    "data-name": "Tracciato 3312",
    d: "M61.994,61.175c-.927.535-.929,2.273,0,3.881s2.433,2.475,3.36,1.94.929-2.273,0-3.881-2.433-2.475-3.36-1.94",
    transform: "translate(20.15 20.058)",
    fill: "#21221f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_298",
    "data-name": "Raggruppa 298",
    transform: "translate(6.981 37.724)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_297",
    "data-name": "Raggruppa 297"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_296",
    "data-name": "Raggruppa 296",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_295",
    "data-name": "Raggruppa 295",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_294",
    "data-name": "Raggruppa 294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_293",
    "data-name": "Raggruppa 293",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_283",
    "data-name": "Raggruppa 283",
    transform: "translate(52.163 26.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_282",
    "data-name": "Raggruppa 282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_281",
    "data-name": "Raggruppa 281",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3313",
    "data-name": "Tracciato 3313",
    d: "M44.512,68.34l34.715-20.2L81,73.151,45.312,93.56Z",
    transform: "translate(-44.512 -48.14)",
    fill: "#ff9a03"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_286",
    "data-name": "Raggruppa 286",
    transform: "translate(5.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_285",
    "data-name": "Raggruppa 285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_284",
    "data-name": "Raggruppa 284",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3314",
    "data-name": "Tracciato 3314",
    d: "M9.683,48.678,45.206,28.39l45.47,26.242-34.715,20.2Z",
    transform: "translate(-9.683 -28.391)",
    fill: "#ffc32b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_289",
    "data-name": "Raggruppa 289",
    transform: "translate(0.899 20.288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_288",
    "data-name": "Raggruppa 288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_287",
    "data-name": "Raggruppa 287",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3315",
    "data-name": "Tracciato 3315",
    d: "M10.917,43.659,57.195,69.812,57.888,91.1l-51.958-30Z",
    transform: "translate(-5.931 -43.659)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_292",
    "data-name": "Raggruppa 292",
    transform: "translate(0 37.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_291",
    "data-name": "Raggruppa 291"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_290",
    "data-name": "Raggruppa 290",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3316",
    "data-name": "Tracciato 3316",
    d: "M58.111,86.787l.27,3.809L5.254,59.934l.9-3.145Z",
    transform: "translate(-5.254 -56.789)",
    fill: "#ff8d23"
  }))))))))))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3317",
    "data-name": "Tracciato 3317",
    d: "M2.994,61.043l5.278-3.068,1.624-.266L4.616,60.776Z",
    transform: "translate(0.984 18.971)",
    fill: "#1c1e20"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3318",
    "data-name": "Tracciato 3318",
    d: "M3.613,57.014l5.278-3.068,1.925,1L5.539,58.015Z",
    transform: "translate(1.188 17.733)",
    fill: "#21221f"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3319",
    "data-name": "Tracciato 3319",
    d: "M15.868,70.92l5.278-3.068-1.281,3.659-5.278,3.067Z",
    transform: "translate(4.795 22.304)",
    fill: "#1d1f20"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3320",
    "data-name": "Tracciato 3320",
    d: "M6.026,55.014l5.279-3.068,1.711,2L7.738,57.013Z",
    transform: "translate(1.981 17.076)",
    fill: "#21221f"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3321",
    "data-name": "Tracciato 3321",
    d: "M16.4,67.91l5.278-3.067.8,5L17.2,72.91Z",
    transform: "translate(5.39 21.315)",
    fill: "#21221f"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3322",
    "data-name": "Tracciato 3322",
    d: "M9.586,55.513l5.278-3.068L15.9,54.91l-5.278,3.068Z",
    transform: "translate(3.151 17.24)",
    fill: "#21221f"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3323",
    "data-name": "Tracciato 3323",
    d: "M7.315,56.85l5.278-3.068,3.019-1.337-5.279,3.068Z",
    transform: "translate(2.404 17.24)",
    fill: "#1c1e1f"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3324",
    "data-name": "Tracciato 3324",
    d: "M15.613,63.944l5.278-3.068,2.667,5-5.279,3.067Z",
    transform: "translate(5.132 20.011)",
    fill: "#21221f"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3325",
    "data-name": "Tracciato 3325",
    d: "M13.339,58.379l5.278-3.067.09,2.267-5.278,3.067Z",
    transform: "translate(4.385 18.182)",
    fill: "#21221f"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3326",
    "data-name": "Tracciato 3326",
    d: "M10.369,57.368,15.647,54.3l3.948,1.345-5.279,3.067Z",
    transform: "translate(3.408 17.85)",
    fill: "#21221f"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3327",
    "data-name": "Tracciato 3327",
    d: "M13.407,60.085l5.278-3.067L22.5,60.682,17.224,63.75Z",
    transform: "translate(4.407 18.743)",
    fill: "#21221f"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3328",
    "data-name": "Tracciato 3328",
    d: "M11.753,54.918l1.04,2.465,3.946,1.343.09,2.267,3.817,3.665-.886,1.463,2.665,5-1.621.267.8,5-1.925-1L18.4,79.047l-1.713-2-3.018,1.337-1.04-2.465L8.681,74.576,8.592,72.31,4.774,68.645l.885-1.463-2.665-5,1.622-.267-.8-5,1.925,1,1.281-3.658,1.713,2Z",
    transform: "translate(0.984 17.835)",
    fill: "#373b3e"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3329",
    "data-name": "Tracciato 3329",
    d: "M16.5,62.843l5.278-3.068-.885,1.463-5.278,3.068Z",
    transform: "translate(5.132 19.649)",
    fill: "#1c1e20"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3330",
    "data-name": "Tracciato 3330",
    d: "M7.666,58.092c-2.243,1.3-2.243,5.494,0,9.379s5.88,5.985,8.122,4.69,2.244-5.5,0-9.381S9.909,56.8,7.666,58.092",
    transform: "translate(1.967 18.97)",
    fill: "#fff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3331",
    "data-name": "Tracciato 3331",
    d: "M9.214,61.14c-.927.535-.929,2.273,0,3.881s2.433,2.475,3.36,1.94.929-2.273,0-3.881-2.432-2.475-3.36-1.94",
    transform: "translate(2.8 20.046)",
    fill: "#21221f"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3332",
    "data-name": "Tracciato 3332",
    d: "M29.314,76.184l5.278-3.068,1.624-.266-5.279,3.067Z",
    transform: "translate(9.636 23.947)",
    fill: "#1c1e20"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3333",
    "data-name": "Tracciato 3333",
    d: "M29.934,72.155l5.278-3.068,1.925,1-5.278,3.068Z",
    transform: "translate(9.84 22.71)",
    fill: "#21221f"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3334",
    "data-name": "Tracciato 3334",
    d: "M42.188,86.06l5.278-3.068-1.281,3.659-5.278,3.067Z",
    transform: "translate(13.447 27.281)",
    fill: "#1d1f20"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3335",
    "data-name": "Tracciato 3335",
    d: "M32.347,70.154l5.279-3.068,1.711,2-5.278,3.067Z",
    transform: "translate(10.633 22.053)",
    fill: "#21221f"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3336",
    "data-name": "Tracciato 3336",
    d: "M42.719,83.05,48,79.984l.8,5L43.518,88.05Z",
    transform: "translate(14.042 26.292)",
    fill: "#21221f"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3337",
    "data-name": "Tracciato 3337",
    d: "M35.906,70.654l5.279-3.068,1.039,2.465-5.278,3.068Z",
    transform: "translate(11.803 22.217)",
    fill: "#21221f"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3338",
    "data-name": "Tracciato 3338",
    d: "M33.635,71.99l5.278-3.068,3.019-1.337-5.279,3.068Z",
    transform: "translate(11.056 22.217)",
    fill: "#1c1e1f"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3339",
    "data-name": "Tracciato 3339",
    d: "M41.934,79.084l5.278-3.068,2.665,5L44.6,84.087Z",
    transform: "translate(13.784 24.988)",
    fill: "#21221f"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3340",
    "data-name": "Tracciato 3340",
    d: "M39.66,73.519l5.278-3.067.09,2.267L39.75,75.786Z",
    transform: "translate(13.037 23.159)",
    fill: "#21221f"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3341",
    "data-name": "Tracciato 3341",
    d: "M36.689,72.508l5.278-3.068,3.948,1.345-5.279,3.067Z",
    transform: "translate(12.06 22.827)",
    fill: "#21221f"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3342",
    "data-name": "Tracciato 3342",
    d: "M39.728,75.226l5.278-3.067,3.817,3.663L43.545,78.89Z",
    transform: "translate(13.059 23.72)",
    fill: "#21221f"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3343",
    "data-name": "Tracciato 3343",
    d: "M38.073,70.059l1.04,2.465,3.946,1.343.09,2.267L46.968,79.8l-.886,1.463,2.665,5-1.621.267.8,5L46,90.53l-1.281,3.658-1.713-2-3.018,1.337-1.04-2.465L35,89.717l-.089-2.267-3.817-3.665.885-1.463-2.665-5,1.622-.267-.8-5,1.924,1L33.343,69.4l1.713,2Z",
    transform: "translate(9.636 22.812)",
    fill: "#373b3e"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3344",
    "data-name": "Tracciato 3344",
    d: "M42.819,77.984,48.1,74.916l-.885,1.463-5.278,3.068Z",
    transform: "translate(13.784 24.626)",
    fill: "#1c1e20"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3345",
    "data-name": "Tracciato 3345",
    d: "M33.986,73.233c-2.243,1.3-2.243,5.494,0,9.379s5.88,5.985,8.122,4.69,2.244-5.5,0-9.381-5.881-5.985-8.124-4.689",
    transform: "translate(10.619 23.947)",
    fill: "#fff"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3346",
    "data-name": "Tracciato 3346",
    d: "M35.534,76.281c-.927.535-.929,2.273,0,3.881s2.433,2.475,3.36,1.94.929-2.273,0-3.881-2.432-2.475-3.36-1.94",
    transform: "translate(11.452 25.023)",
    fill: "#21221f"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3347",
    "data-name": "Tracciato 3347",
    d: "M13.012,44.408a2.692,2.692,0,0,0,.482.352,5.319,5.319,0,0,0,3.443.493,4.411,4.411,0,0,0,1.414-.493,1.723,1.723,0,0,0,1.014-1.416v.384a1.715,1.715,0,0,1-1.012,1.416,4.381,4.381,0,0,1-1.414.494,5.324,5.324,0,0,1-3.444-.493,2.728,2.728,0,0,1-.481-.352,1.445,1.445,0,0,1-.517-1.046v-.385a1.445,1.445,0,0,0,.517,1.046",
    transform: "translate(4.107 14.248)",
    fill: "#d83736"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3348",
    "data-name": "Tracciato 3348",
    d: "M13.509,42.437c-1.346.777-1.353,2.037-.016,2.813a5.349,5.349,0,0,0,4.856,0c1.346-.776,1.353-2.036.016-2.813a5.349,5.349,0,0,0-4.856,0",
    transform: "translate(4.107 13.759)",
    fill: "#ff4140"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3349",
    "data-name": "Tracciato 3349",
    d: "M15.178,27.992l1.244-.723-.011,21.952-1.244.723Z",
    transform: "translate(4.986 8.964)",
    fill: "#969696"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3350",
    "data-name": "Tracciato 3350",
    d: "M14.09,27.366l1.244-.723,1.442.832-1.244.723Z",
    transform: "translate(4.632 8.758)",
    fill: "#c1c1c1"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3351",
    "data-name": "Tracciato 3351",
    d: "M15.534,28.019l-.011,21.952-1.442-.833.011-21.95Z",
    transform: "translate(4.629 8.937)",
    fill: "#dfdfdf"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3352",
    "data-name": "Tracciato 3352",
    d: "M15.12,29.853l1.9-1.1a.228.228,0,0,1-.094.209l-1.9,1.1a.23.23,0,0,0,.094-.209",
    transform: "translate(4.939 9.451)",
    fill: "#ebebeb"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3353",
    "data-name": "Tracciato 3353",
    d: "M13.577,27.511l1.9-1.1a.229.229,0,0,1,.231.023l-1.9,1.1a.229.229,0,0,0-.231-.023",
    transform: "translate(4.463 8.674)",
    fill: "#c9c9c9"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3354",
    "data-name": "Tracciato 3354",
    d: "M15.1,28.583l1.9-1.1-.005,1.687-1.9,1.1Z",
    transform: "translate(4.962 9.034)",
    fill: "#f5f5f5"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3355",
    "data-name": "Tracciato 3355",
    d: "M13.751,27.523l1.9-1.1,1.47.848-1.9,1.1Z",
    transform: "translate(4.52 8.685)",
    fill: "#dcdcdc"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3356",
    "data-name": "Tracciato 3356",
    d: "M14.856,28.161l1.9-1.1a.716.716,0,0,1,.324.561l-1.9,1.1a.716.716,0,0,0-.324-.561",
    transform: "translate(4.883 8.895)",
    fill: "#ebebeb"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3357",
    "data-name": "Tracciato 3357",
    d: "M15.3,28.109a.716.716,0,0,1,.324.561l-.005,1.687c0,.206-.146.29-.326.186l-1.47-.848a.711.711,0,0,1-.323-.561l0-1.687c0-.207.147-.29.327-.186Z",
    transform: "translate(4.438 8.947)",
    fill: "#bfbfbf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_316",
    "data-name": "Raggruppa 316",
    transform: "translate(11.659 36.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_315",
    "data-name": "Raggruppa 315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_314",
    "data-name": "Raggruppa 314",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_313",
    "data-name": "Raggruppa 313",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_312",
    "data-name": "Raggruppa 312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_311",
    "data-name": "Raggruppa 311",
    clipPath: "url(#clip-path-8)"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_301",
    "data-name": "Raggruppa 301",
    transform: "translate(0.259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_300",
    "data-name": "Raggruppa 300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_299",
    "data-name": "Raggruppa 299",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3358",
    "data-name": "Tracciato 3358",
    d: "M8.97,31.362,15.5,27.639a.561.561,0,0,1,.5,0L9.472,31.359a.561.561,0,0,0-.5,0",
    transform: "translate(-8.97 -27.579)",
    fill: "#9f9f9f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_307",
    "data-name": "Raggruppa 307",
    transform: "translate(0.762 0.058)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_306",
    "data-name": "Raggruppa 306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_305",
    "data-name": "Raggruppa 305",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_304",
    "data-name": "Raggruppa 304",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_303",
    "data-name": "Raggruppa 303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_302",
    "data-name": "Raggruppa 302",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3359",
    "data-name": "Tracciato 3359",
    d: "M16.01,27.687a1.067,1.067,0,0,0-.13-.064L9.348,31.345a1.081,1.081,0,0,1,.13.065,1.985,1.985,0,0,1,.868,1.311L16.878,29a1.985,1.985,0,0,0-.868-1.311",
    transform: "translate(-9.349 -27.623)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3360",
    "data-name": "Tracciato 3360",
    d: "M10.158,32.381l6.532-3.723a1.445,1.445,0,0,1,.019.223.623.623,0,0,1-.259.571L9.918,33.174a.622.622,0,0,0,.259-.57,1.432,1.432,0,0,0-.019-.223",
    transform: "translate(-9.161 -27.283)",
    fill: "#9f9f9f"
  })))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_310",
    "data-name": "Raggruppa 310",
    transform: "translate(0 3.723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_309",
    "data-name": "Raggruppa 309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_308",
    "data-name": "Raggruppa 308",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3361",
    "data-name": "Tracciato 3361",
    d: "M9.667,30.5a1.952,1.952,0,0,1,.886,1.535c0,.565-.4.792-.892.509a1.951,1.951,0,0,1-.886-1.535c0-.565.4-.792.892-.509",
    transform: "translate(-8.775 -30.381)",
    fill: "#f0910a"
  }))))))))))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3362",
    "data-name": "Tracciato 3362",
    d: "M9.738,32.636l1.9-1.1a.228.228,0,0,1-.094.209l-1.9,1.1a.228.228,0,0,0,.094-.209",
    transform: "translate(3.17 10.366)",
    fill: "#ebebeb"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3363",
    "data-name": "Tracciato 3363",
    d: "M8.195,30.293l1.9-1.1a.229.229,0,0,1,.231.023l-1.9,1.1a.229.229,0,0,0-.231-.023",
    transform: "translate(2.694 9.589)",
    fill: "#c9c9c9"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3364",
    "data-name": "Tracciato 3364",
    d: "M9.72,31.365l1.9-1.1-.005,1.687-1.9,1.1Z",
    transform: "translate(3.193 9.948)",
    fill: "#f5f5f5"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3365",
    "data-name": "Tracciato 3365",
    d: "M8.369,30.305l1.9-1.1,1.468.848-1.9,1.1Z",
    transform: "translate(2.751 9.6)",
    fill: "#dcdcdc"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3366",
    "data-name": "Tracciato 3366",
    d: "M9.475,30.944l1.9-1.1a.716.716,0,0,1,.324.561L9.8,31.5a.716.716,0,0,0-.324-.561",
    transform: "translate(3.115 9.81)",
    fill: "#ebebeb"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3367",
    "data-name": "Tracciato 3367",
    d: "M9.92,30.892a.716.716,0,0,1,.324.561l-.005,1.687c0,.206-.146.29-.326.186l-1.47-.848a.711.711,0,0,1-.323-.561l.005-1.689c0-.206.146-.288.326-.185Z",
    transform: "translate(2.669 9.862)",
    fill: "#bfbfbf"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3368",
    "data-name": "Tracciato 3368",
    d: "M9.644,22.386l1.244-.723L10.877,32.91l-1.244.721Z",
    transform: "translate(3.167 7.122)",
    fill: "#969696"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3369",
    "data-name": "Tracciato 3369",
    d: "M8.557,21.76,9.8,21.037l1.442.832L10,22.592Z",
    transform: "translate(2.813 6.916)",
    fill: "#c1c1c1"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3370",
    "data-name": "Tracciato 3370",
    d: "M10,22.413,9.99,33.658l-1.442-.832.011-11.245Z",
    transform: "translate(2.81 7.095)",
    fill: "#dfdfdf"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_320",
    "data-name": "Raggruppa 320",
    transform: "translate(0.133 22.381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_319",
    "data-name": "Raggruppa 319",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3371",
    "data-name": "Tracciato 3371",
    d: "M1.3,23.147l10.846-6.3c-.818.623-1.067,1.941-1.2,3.15L.1,26.3c.134-1.209.384-2.527,1.2-3.15",
    transform: "translate(-0.1 -16.844)",
    fill: "#9f9f9f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_383",
    "data-name": "Raggruppa 383",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_382",
    "data-name": "Raggruppa 382",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_351",
    "data-name": "Raggruppa 351",
    transform: "translate(1.556 22.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_350",
    "data-name": "Raggruppa 350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_349",
    "data-name": "Raggruppa 349",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_348",
    "data-name": "Raggruppa 348",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_347",
    "data-name": "Raggruppa 347"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_346",
    "data-name": "Raggruppa 346",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_330",
    "data-name": "Raggruppa 330",
    transform: "translate(1.174 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_329",
    "data-name": "Raggruppa 329",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_324",
    "data-name": "Raggruppa 324",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_323",
    "data-name": "Raggruppa 323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_322",
    "data-name": "Raggruppa 322",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3373",
    "data-name": "Tracciato 3373",
    d: "M2.055,22.763l9.523-5.534a2.311,2.311,0,0,1,1.749-.185L3.8,22.579a2.309,2.309,0,0,0-1.747.183",
    transform: "translate(-2.055 -16.956)",
    fill: "#011824"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_327",
    "data-name": "Raggruppa 327",
    transform: "translate(1.748 0.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_326",
    "data-name": "Raggruppa 326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_325",
    "data-name": "Raggruppa 325",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3374",
    "data-name": "Tracciato 3374",
    d: "M3.371,22.556l9.523-5.534a4.3,4.3,0,0,1,1.119.465L4.488,23.021a4.29,4.29,0,0,0-1.117-.465",
    transform: "translate(-3.37 -17.022)",
    fill: "#011d2b"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_341",
    "data-name": "Raggruppa 341",
    transform: "translate(4.04 0.553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_340",
    "data-name": "Raggruppa 340",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_335",
    "data-name": "Raggruppa 335",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_334",
    "data-name": "Raggruppa 334"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_333",
    "data-name": "Raggruppa 333",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3376",
    "data-name": "Tracciato 3376",
    d: "M4.212,22.906l9.523-5.534a8.8,8.8,0,0,1,3.52,4.427L7.732,27.333a8.8,8.8,0,0,0-3.52-4.427",
    transform: "translate(-4.212 -17.372)",
    fill: "#011d2b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_338",
    "data-name": "Raggruppa 338",
    transform: "translate(2.839 4.428)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_337",
    "data-name": "Raggruppa 337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_336",
    "data-name": "Raggruppa 336",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3377",
    "data-name": "Tracciato 3377",
    d: "M7.029,26.238,16.552,20.7a7.229,7.229,0,0,1,.494,2.525,2.819,2.819,0,0,1-1.175,2.583L6.349,31.346a2.819,2.819,0,0,0,1.175-2.583,7.29,7.29,0,0,0-.494-2.525",
    transform: "translate(-6.349 -20.704)",
    fill: "#9f9f9f"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_345",
    "data-name": "Raggruppa 345",
    transform: "translate(0 5.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_344",
    "data-name": "Raggruppa 344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_343",
    "data-name": "Raggruppa 343",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3379",
    "data-name": "Tracciato 3379",
    d: "M5.212,21.674a8.847,8.847,0,0,1,4.014,6.952c-.008,2.556-1.815,3.588-4.041,2.3a8.847,8.847,0,0,1-4.014-6.952c.008-2.556,1.816-3.586,4.041-2.3",
    transform: "translate(-1.171 -21.121)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3380",
    "data-name": "Tracciato 3380",
    d: "M6.9,31.013a3.338,3.338,0,0,1-1.62-.5,8.446,8.446,0,0,1-3.827-6.626c.005-1.531.716-2.481,1.858-2.481a3.32,3.32,0,0,1,1.62.5,8.446,8.446,0,0,1,3.827,6.626c0,1.531-.716,2.481-1.858,2.481",
    transform: "translate(-1.079 -21.028)",
    fill: "#283033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3381",
    "data-name": "Tracciato 3381",
    d: "M6.853,30.78A3.15,3.15,0,0,1,5.327,30.3,8.238,8.238,0,0,1,1.6,23.838c0-1.414.643-2.293,1.669-2.293a3.139,3.139,0,0,1,1.527.478,8.235,8.235,0,0,1,3.732,6.463c0,1.415-.644,2.293-1.67,2.293",
    transform: "translate(-1.032 -20.982)",
    fill: "#00b5ac"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_381",
    "data-name": "Raggruppa 381",
    transform: "translate(0 21.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_380",
    "data-name": "Raggruppa 380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_379",
    "data-name": "Raggruppa 379",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_378",
    "data-name": "Raggruppa 378",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_377",
    "data-name": "Raggruppa 377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_376",
    "data-name": "Raggruppa 376",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_359",
    "data-name": "Raggruppa 359",
    transform: "translate(1.239)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_358",
    "data-name": "Raggruppa 358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_357",
    "data-name": "Raggruppa 357",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_356",
    "data-name": "Raggruppa 356",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_355",
    "data-name": "Raggruppa 355",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_354",
    "data-name": "Raggruppa 354",
    transform: "translate(0 0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_353",
    "data-name": "Raggruppa 353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_352",
    "data-name": "Raggruppa 352",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3382",
    "data-name": "Tracciato 3382",
    d: "M.933,23.091l10.846-6.3a3.064,3.064,0,0,1,2.058-.162l-10.846,6.3a3.056,3.056,0,0,0-2.058.163",
    transform: "translate(-0.933 -16.521)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3383",
    "data-name": "Tracciato 3383",
    d: "M2.482,22.9l10.846-6.3a4.717,4.717,0,0,1,1.221.5L3.7,23.406a4.7,4.7,0,0,0-1.221-.5",
    transform: "translate(-0.423 -16.495)",
    fill: "#fff"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_367",
    "data-name": "Raggruppa 367",
    transform: "translate(4.519 0.608)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_366",
    "data-name": "Raggruppa 366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_365",
    "data-name": "Raggruppa 365",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_364",
    "data-name": "Raggruppa 364",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_363",
    "data-name": "Raggruppa 363",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_362",
    "data-name": "Raggruppa 362",
    transform: "translate(0 0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_361",
    "data-name": "Raggruppa 361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_360",
    "data-name": "Raggruppa 360",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3385",
    "data-name": "Tracciato 3385",
    d: "M3.4,23.281l10.846-6.3a7.871,7.871,0,0,1,2.267,2.082l-10.846,6.3A7.848,7.848,0,0,0,3.4,23.281",
    transform: "translate(-3.401 -16.978)",
    fill: "#fff"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_372",
    "data-name": "Raggruppa 372",
    transform: "translate(6.786 2.689)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_371",
    "data-name": "Raggruppa 371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_370",
    "data-name": "Raggruppa 370",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_369",
    "data-name": "Raggruppa 369",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_368",
    "data-name": "Raggruppa 368",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3387",
    "data-name": "Tracciato 3387",
    d: "M5.107,24.847l10.846-6.3A12.31,12.31,0,0,1,17.5,21.4L6.654,27.7a12.276,12.276,0,0,0-1.547-2.855",
    transform: "translate(-5.107 -18.545)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3388",
    "data-name": "Tracciato 3388",
    d: "M6.271,27l10.846-6.3a8.475,8.475,0,0,1,.579,3.041L6.85,30.038A8.418,8.418,0,0,0,6.271,27",
    transform: "translate(-4.724 -17.839)",
    fill: "#e5e5e5"
  }))))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_375",
    "data-name": "Raggruppa 375",
    transform: "translate(0 6.303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_374",
    "data-name": "Raggruppa 374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_373",
    "data-name": "Raggruppa 373",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3390",
    "data-name": "Tracciato 3390",
    d: "M4.519,21.872a7.848,7.848,0,0,1,2.267,2.081,10.293,10.293,0,0,1,2.126,5.9l-.134-.08a9.991,9.991,0,0,0-2.066-5.733,7.6,7.6,0,0,0-2.192-2.013,3.411,3.411,0,0,0-3.185-.331c-.818.623-1.067,1.941-1.2,3.15L0,24.75c.138-1.229.392-2.574,1.24-3.218a3.513,3.513,0,0,1,3.279.34",
    transform: "translate(0 -21.264)",
    fill: "#fff"
  }))))))))))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3391",
    "data-name": "Tracciato 3391",
    d: "M34.38,32.005a2.625,2.625,0,0,0,.482.351,5.31,5.31,0,0,0,3.443.494,4.381,4.381,0,0,0,1.414-.494,1.719,1.719,0,0,0,1.014-1.415v.384a1.719,1.719,0,0,1-1.014,1.416,4.413,4.413,0,0,1-1.414.494,5.316,5.316,0,0,1-3.444-.494,2.66,2.66,0,0,1-.481-.351,1.44,1.44,0,0,1-.517-1.046V30.96a1.439,1.439,0,0,0,.516,1.046",
    transform: "translate(11.132 10.171)",
    fill: "#d83736"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3392",
    "data-name": "Tracciato 3392",
    d: "M34.878,30.033c-1.346.777-1.353,2.037-.016,2.813a5.349,5.349,0,0,0,4.856,0c1.346-.776,1.353-2.036.016-2.813a5.349,5.349,0,0,0-4.856,0",
    transform: "translate(11.132 9.681)",
    fill: "#ff4140"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3393",
    "data-name": "Tracciato 3393",
    d: "M36.37,15.163l1.244-.723L37.6,36.392l-1.244.723Z",
    transform: "translate(11.952 4.747)",
    fill: "#969696"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3394",
    "data-name": "Tracciato 3394",
    d: "M35.283,14.536l1.244-.723,1.442.832-1.244.723Z",
    transform: "translate(11.598 4.541)",
    fill: "#c1c1c1"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3395",
    "data-name": "Tracciato 3395",
    d: "M36.727,15.19l-.011,21.952-1.442-.833.011-21.95Z",
    transform: "translate(11.595 4.72)",
    fill: "#dfdfdf"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3396",
    "data-name": "Tracciato 3396",
    d: "M27.266,30.037l-1.94-1.127-.05-18.219,1.939,1.128Z",
    transform: "translate(8.308 3.515)",
    fill: "#848484"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3397",
    "data-name": "Tracciato 3397",
    d: "M27.215,15.332l-1.94-1.127L49.879,0l1.94,1.127Z",
    transform: "translate(8.308 0.001)",
    fill: "#bababa"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3398",
    "data-name": "Tracciato 3398",
    d: "M51.338.848l.052,18.218-24.6,14.205-.052-18.218Z",
    transform: "translate(8.788 0.279)",
    fill: "#fff"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3399",
    "data-name": "Tracciato 3399",
    d: "M34.417,16.492l-6.624,3.824V12.7l6.624-3.824Z",
    transform: "translate(9.136 2.919)",
    fill: "#00447d"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3400",
    "data-name": "Tracciato 3400",
    d: "M40.268,13.115l-6.624,3.824V9.324L40.268,5.5Z",
    transform: "translate(11.059 1.808)",
    fill: "#00447d"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3401",
    "data-name": "Tracciato 3401",
    d: "M46.118,9.737l-6.624,3.824V5.946l6.624-3.824Z",
    transform: "translate(12.982 0.698)",
    fill: "#00447d"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3402",
    "data-name": "Tracciato 3402",
    d: "M34.417,22.982l-6.624,3.824V19.191l6.624-3.824Z",
    transform: "translate(9.136 5.052)",
    fill: "#00447d"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3403",
    "data-name": "Tracciato 3403",
    d: "M40.268,19.6l-6.624,3.824V15.813l6.624-3.824Z",
    transform: "translate(11.059 3.942)",
    fill: "#00447d"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3404",
    "data-name": "Tracciato 3404",
    d: "M46.118,16.227l-6.624,3.824V12.436l6.624-3.824Z",
    transform: "translate(12.982 2.831)",
    fill: "#00447d"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3405",
    "data-name": "Tracciato 3405",
    d: "M72.112,49.062a17.749,17.749,0,0,0-.423-2.268,27.044,27.044,0,0,0-.933-2.784,18.609,18.609,0,0,0-1.1-2.2,22.728,22.728,0,0,0-1.6-2.343,28.839,28.839,0,0,0-1.989-2.16,14.659,14.659,0,0,0-1.375-1.192c-.715-.541-1.7-1.216-2.454-1.7a24.022,24.022,0,0,0-3.047-1.553c-.4-.163-.927-.391-1.335-.526s-.939-.324-1.347-.448-.983-.271-1.406-.385c-.5-.136-2.1-.454-2.72-.531-.407-.05-.946-.134-1.354-.166-.809-.062-1.889-.137-2.7-.147-.868-.012-.971-.007-2.7.093-.412.023-.957.1-1.366.138-.6.062-2.146.331-2.752.478-.441.108-1.032.237-1.466.371-.816.251-1.9.613-2.695.914a24.089,24.089,0,0,0-2.9,1.379,22.531,22.531,0,0,0-4.625,3.394,21.835,21.835,0,0,0-1.81,1.966,27.754,27.754,0,0,0-1.666,2.41,19.424,19.424,0,0,0-1.815,4.146,24,24,0,0,0-.579,2.533c-.129.886-.194,2.082-.227,2.978.009,3.492,2.252,6.982,6.755,9.693,9.277,5.583,24.637,5.739,34.307.347,4.976-2.774,7.477-6.479,7.466-10.181-.016-.679-.058-1.584-.142-2.257",
    transform: "translate(7.799 10.077)",
    fill: "#fff"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3406",
    "data-name": "Tracciato 3406",
    d: "M60.734,47.349a20.091,20.091,0,0,0-.753-14.134c-.36-.169-.632-.286-.793-.352-.4-.162-.927-.389-1.337-.525s-.939-.324-1.346-.448-.985-.272-1.407-.387c-.5-.136-2.1-.453-2.72-.531-.407-.05-.946-.134-1.354-.166-.809-.062-1.888-.136-2.7-.147-.868-.011-.971-.005-2.7.093-.411.024-.957.1-1.366.14-.6.062-2.146.331-2.752.478-.44.106-1.031.237-1.464.369-.816.252-1.9.614-2.7.915a24,24,0,0,0-2.9,1.378,22.711,22.711,0,0,0-4.625,3.394,22.048,22.048,0,0,0-1.81,1.968,27.056,27.056,0,0,0-1.665,2.41,19.359,19.359,0,0,0-1.816,4.144,24.431,24.431,0,0,0-.578,2.534c-.13.886-.2,2.082-.229,2.978a8.7,8.7,0,0,0,.9,3.747c12.7,7.9,32.825,5.29,36.112-7.858",
    transform: "translate(7.799 10.077)",
    fill: "#e6e6e6"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3407",
    "data-name": "Tracciato 3407",
    d: "M71.89,48.428a17.751,17.751,0,0,0-.423-2.268,27.045,27.045,0,0,0-.933-2.784,18.61,18.61,0,0,0-1.1-2.2,22.728,22.728,0,0,0-1.6-2.343,28.839,28.839,0,0,0-1.989-2.16,14.659,14.659,0,0,0-1.375-1.192c-.715-.541-1.7-1.216-2.454-1.7-.922-.546-1.694-.939-2.252-1.2a20.087,20.087,0,0,1,.753,14.132C57.225,59.864,37.1,62.479,24.4,54.573a14.594,14.594,0,0,0,5.858,5.946c9.277,5.583,24.637,5.739,34.307.347,4.976-2.774,7.477-6.479,7.466-10.181-.016-.679-.058-1.584-.142-2.257",
    transform: "translate(8.021 10.711)",
    fill: "#d4d4d4"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3408",
    "data-name": "Tracciato 3408",
    d: "M3.965,53.207l.005,1.749,34.759,20.2-.005-1.749Z",
    transform: "translate(1.303 17.49)",
    fill: "#c5c5c5"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3409",
    "data-name": "Tracciato 3409",
    d: "M30.125,70.559l.005,1.749L45.108,63.62,45.1,61.871Z",
    transform: "translate(9.902 20.339)",
    fill: "#898989"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3410",
    "data-name": "Tracciato 3410",
    d: "M3.965,55.356l34.759,20.2L53.7,66.869l-34.759-20.2Z",
    transform: "translate(1.303 15.341)",
    fill: "#fff"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3411",
    "data-name": "Tracciato 3411",
    d: "M16.725,53.9l-5.609,3.238L5.507,53.9l5.61-3.238Z",
    transform: "translate(1.81 16.653)",
    fill: "#00447d"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3412",
    "data-name": "Tracciato 3412",
    d: "M21.931,50.893l-5.609,3.238-5.61-3.238,5.61-3.238Z",
    transform: "translate(3.522 15.665)",
    fill: "#00447d"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3413",
    "data-name": "Tracciato 3413",
    d: "M21.744,56.8l-5.609,3.238L10.526,56.8l5.61-3.238Z",
    transform: "translate(3.46 17.606)",
    fill: "#00447d"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3414",
    "data-name": "Tracciato 3414",
    d: "M26.95,53.791l-5.609,3.238-5.61-3.238,5.61-3.238Z",
    transform: "translate(5.171 16.618)",
    fill: "#00447d"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3415",
    "data-name": "Tracciato 3415",
    d: "M26.763,59.694l-5.609,3.238-5.61-3.238,5.61-3.238Z",
    transform: "translate(5.11 18.558)",
    fill: "#00447d"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3416",
    "data-name": "Tracciato 3416",
    d: "M31.969,56.688,26.36,59.926l-5.61-3.238,5.61-3.238Z",
    transform: "translate(6.821 17.57)",
    fill: "#00447d"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3417",
    "data-name": "Tracciato 3417",
    d: "M31.781,62.592,26.173,65.83l-5.61-3.238,5.61-3.238Z",
    transform: "translate(6.759 19.511)",
    fill: "#00447d"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3418",
    "data-name": "Tracciato 3418",
    d: "M36.988,59.586l-5.609,3.238-5.61-3.238,5.61-3.238Z",
    transform: "translate(8.471 18.523)",
    fill: "#00447d"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3419",
    "data-name": "Tracciato 3419",
    d: "M36.8,65.489l-5.609,3.238-5.61-3.238,5.61-3.238Z",
    transform: "translate(8.409 20.463)",
    fill: "#00447d"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3420",
    "data-name": "Tracciato 3420",
    d: "M42.006,62.483,36.4,65.721l-5.61-3.238,5.61-3.238Z",
    transform: "translate(10.12 19.475)",
    fill: "#00447d"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3421",
    "data-name": "Tracciato 3421",
    d: "M38.589,39.859a4.016,4.016,0,1,1-4.015-3.922,3.97,3.97,0,0,1,4.015,3.922",
    transform: "translate(10.046 11.814)",
    fill: "#fff"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3422",
    "data-name": "Tracciato 3422",
    d: "M82.4,50.7l-.021,7.656-33.318,19.5.021-7.656Z",
    transform: "translate(16.127 16.665)",
    fill: "#f23e3a"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3423",
    "data-name": "Tracciato 3423",
    d: "M50.418,66.126,50.4,73.782,45,70.748l.023-7.656Z",
    transform: "translate(14.791 20.74)",
    fill: "#b52e2b"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3424",
    "data-name": "Tracciato 3424",
    d: "M83.73,51.448l-33.318,19.5-5.4-3.035,33.318-19.5Z",
    transform: "translate(14.796 15.915)",
    fill: "#fe534f"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3425",
    "data-name": "Tracciato 3425",
    d: "M50.57,29.81,48.64,18.372a.429.429,0,0,1-.194.388,1.326,1.326,0,0,1-1.189.191.425.425,0,0,1-.3-.3l3.157,18.7a.425.425,0,0,0,.3.3,1.33,1.33,0,0,0,1.189-.191.429.429,0,0,0,.193-.388Z",
    transform: "translate(15.435 6.04)",
    fill: "#082c44"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_385",
    "data-name": "Raggruppa 385",
    transform: "translate(62.394 24.413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_384",
    "data-name": "Raggruppa 384",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3426",
    "data-name": "Tracciato 3426",
    d: "M46.958,18.58l3.157,18.7a.276.276,0,0,0,.015.054l-3.157-18.7a.254.254,0,0,1-.015-.054",
    transform: "translate(-46.958 -18.305)",
    fill: "#082c44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3427",
    "data-name": "Tracciato 3427",
    d: "M46.969,18.621l3.157,18.7a.458.458,0,0,0,.284.248,1.206,1.206,0,0,0,.586.05l-3.156-18.7a1.22,1.22,0,0,1-.586-.052.465.465,0,0,1-.286-.248",
    transform: "translate(-46.954 -18.291)",
    fill: "#082c44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3428",
    "data-name": "Tracciato 3428",
    d: "M47.625,19l3.157,18.7a1.252,1.252,0,0,0,.6-.244.429.429,0,0,0,.193-.387l-3.157-18.7a.425.425,0,0,1-.193.388,1.251,1.251,0,0,1-.6.243",
    transform: "translate(-46.739 -18.373)",
    fill: "#082c44"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_387",
    "data-name": "Raggruppa 387",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_386",
    "data-name": "Raggruppa 386",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3430",
    "data-name": "Tracciato 3430",
    d: "M47.152,18.352a.37.37,0,0,0,.106.691,1.329,1.329,0,0,0,1.191-.193.369.369,0,0,0-.106-.69,1.328,1.328,0,0,0-1.191.191",
    transform: "translate(15.435 5.948)",
    fill: "#0b1b2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3431",
    "data-name": "Tracciato 3431",
    d: "M50.117,18.443a2.149,2.149,0,1,0-2.149,2.149,2.149,2.149,0,0,0,2.149-2.149",
    transform: "translate(15.062 5.357)",
    fill: "#fe534f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3432",
    "data-name": "Tracciato 3432",
    d: "M48.979,16.579a2.126,2.126,0,0,1,.157,1.731,3.376,3.376,0,0,1-2.695,1.719,2.143,2.143,0,1,0,2.538-3.451",
    transform: "translate(15.266 5.45)",
    fill: "#f23e3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3433",
    "data-name": "Tracciato 3433",
    d: "M48,17.5a.81.81,0,1,0-.811.811A.81.81,0,0,0,48,17.5",
    transform: "translate(15.246 5.487)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3434",
    "data-name": "Tracciato 3434",
    d: "M60.564,33.847l10-5.877a.43.43,0,0,1-.432-.043,1.328,1.328,0,0,1-.6-1.043.422.422,0,0,1,.175-.388L53.361,36.106a.423.423,0,0,0-.177.388,1.326,1.326,0,0,0,.6,1.043.428.428,0,0,0,.431.043Z",
    transform: "translate(17.482 8.71)",
    fill: "#082c44"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_389",
    "data-name": "Raggruppa 389",
    transform: "translate(70.668 35.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_388",
    "data-name": "Raggruppa 388",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3435",
    "data-name": "Tracciato 3435",
    d: "M69.674,26.5,53.33,36.105a.228.228,0,0,0-.047.033l16.345-9.609a.372.372,0,0,1,.047-.033",
    transform: "translate(-53.153 -26.497)",
    fill: "#082c44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3436",
    "data-name": "Tracciato 3436",
    d: "M69.66,26.521,53.316,36.13a.459.459,0,0,0-.132.355,1.216,1.216,0,0,0,.161.566l16.346-9.609a1.19,1.19,0,0,1-.161-.566.459.459,0,0,1,.13-.355",
    transform: "translate(-53.185 -26.489)",
    fill: "#082c44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3437",
    "data-name": "Tracciato 3437",
    d: "M69.651,27.215,53.306,36.824a1.232,1.232,0,0,0,.442.477.427.427,0,0,0,.431.043l16.345-9.609a.428.428,0,0,1-.43-.043,1.252,1.252,0,0,1-.442-.477",
    transform: "translate(-53.145 -26.261)",
    fill: "#082c44"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_391",
    "data-name": "Raggruppa 391",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_390",
    "data-name": "Raggruppa 390",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3439",
    "data-name": "Tracciato 3439",
    d: "M66.093,26.549c-.335-.193-.606-.039-.607.345a1.332,1.332,0,0,0,.6,1.044c.335.193.606.037.607-.345a1.326,1.326,0,0,0-.6-1.044",
    transform: "translate(21.526 8.7)",
    fill: "#0b1b2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3440",
    "data-name": "Tracciato 3440",
    d: "M68.621,27.4a2.149,2.149,0,1,0-2.149,2.149A2.149,2.149,0,0,0,68.621,27.4",
    transform: "translate(21.144 8.301)",
    fill: "#fe534f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3441",
    "data-name": "Tracciato 3441",
    d: "M67.484,25.535a2.126,2.126,0,0,1,.157,1.731,3.373,3.373,0,0,1-2.695,1.719,2.143,2.143,0,1,0,2.538-3.451",
    transform: "translate(21.349 8.394)",
    fill: "#f23e3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3442",
    "data-name": "Tracciato 3442",
    d: "M66.5,26.459a.81.81,0,1,0-.811.811.81.81,0,0,0,.811-.811",
    transform: "translate(21.329 8.431)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ2);
export default __webpack_public_path__ + "static/media/q2.dc4bedae169470d9af718919e51e23ff.svg";
export { ForwardRef as ReactComponent };